import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "opportunities-section" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"top-icon\"><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"30\" cy=\"30\" r=\"30\" fill=\"url(#paint0_linear_513_30243)\"></circle><path d=\"M37.9553 26.6163C37.7209 26.3819 37.403 26.2503 37.0716 26.2503C36.7401 26.2503 36.4222 26.3819 36.1878 26.6163L30.0003 32.8038L23.8128 26.6163C23.5771 26.3886 23.2613 26.2626 22.9336 26.2654C22.6058 26.2683 22.2923 26.3997 22.0605 26.6315C21.8288 26.8632 21.6973 27.1768 21.6945 27.5045C21.6916 27.8322 21.8176 28.148 22.0453 28.3838L29.1166 35.455C29.351 35.6893 29.6689 35.821 30.0003 35.821C30.3318 35.821 30.6496 35.6893 30.8841 35.455L37.9553 28.3838C38.1896 28.1493 38.3213 27.8315 38.3213 27.5C38.3213 27.1685 38.1896 26.8507 37.9553 26.6163Z\" fill=\"white\"></path><defs><linearGradient id=\"paint0_linear_513_30243\" x1=\"30\" y1=\"0\" x2=\"30\" y2=\"60\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#0189FF\"></stop><stop offset=\"1\" stop-color=\"#0167FF\"></stop></linearGradient></defs></svg></div>", 1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-md-0 mt-4" }, "Какие возможности мы предлагаем?", -1)
const _hoisted_5 = { class: "row justify-content-between gy-2" }
const _hoisted_6 = { class: "main-card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "opportunity-title mt-4" }
const _hoisted_9 = { class: "hover-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (opp, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "opportunity-item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: opp.icon
              }, null, 8, _hoisted_7),
              _createElementVNode("h4", _hoisted_8, _toDisplayString(opp.title), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(opp.description), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}